import React, { Fragment } from 'react';
import { number } from 'prop-types';
import { FormattedPlural, IntlProvider } from 'react-intl';

import s from './index.module.css';
import { ReactComponent as PlacemarkIcon } from '../assets/balloon.svg';
import { formatAmount } from '../../../utils';

const Placemark = ({ price, delivery }) => {
  const days = delivery > 0
    ? <Fragment>{delivery}&nbsp;
      <FormattedPlural
        value={delivery}
        one={'день'}
        few={'дня'}
        many={'дней'}
        other={'дней'}
      />
    </Fragment>
    : 'сегодня';

  return (
    <IntlProvider locale="ru" defaultLocale="ru">
      <div className={s.placemark}>
        <PlacemarkIcon className={s.icon} />
        <span className={s.text}>
          {days},&nbsp;
          {formatAmount(price, true)} ₽
        </span>
      </div>
    </IntlProvider>
  );
};

Placemark.propTypes = {
  price: number,
  delivery: number,
};

Placemark.defaultProps = {
  price: 1000,
  delivery: 5,
};

export default Placemark;
